import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MobileDialogData } from '../../common';

@Component({
    selector: 'nphs-user-reservations-popup',
    templateUrl: './manufacturer-order-popup.component.html',
    styleUrls: ['./manufacturer-order-popup.component.scss'],
    standalone: false
})
export class ManufacturerOrderPopupComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ManufacturerOrderPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MobileDialogData) { }

  ngOnInit(): void {
  }

  OncloseManufacturerOrderPopup(){
    this.dialogRef.close({data:false})
  }

  onViewClick(){
    this.dialogRef.close({data:true})
  }

}
